import { useDispatch } from "react-redux";
import { goBackToPenal } from "../redux/thunks/loginThunk";
import toast from "react-hot-toast";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const GoBackBtn = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [isAdminLogin, setIsAdminLogin] = useState(false);

  useEffect(() => {
    const checkAdmin = () => {
      const flag = sessionStorage.getItem("is_admin_login") === "1";
      setIsAdminLogin(flag);
    };

    checkAdmin();

    // 👇 custom event (since sessionStorage doesn't trigger storage event)
    window.addEventListener("adminLoginChanged", checkAdmin);

    return () => {
      window.removeEventListener("adminLoginChanged", checkAdmin);
    };
  }, []);

  if (!isAdminLogin || location.pathname === "/login") return null;

  const handleBackToAdmin = async () => {
    const adminId = sessionStorage.getItem("admin_id");

    const payload = {
      admin_id: adminId,
      is_admin_redirect: 1,
    };

    try {
      const res = await dispatch(goBackToPenal(payload)).unwrap();

      if (res?.status && res?.data?.userAccessToken) {
        const token = res.data.userAccessToken;

        // ✅ clear ONLY this tab
        sessionStorage.removeItem("is_admin_login");
        sessionStorage.removeItem("admin_id");   
        sessionStorage.removeItem("9zIBz91iaMa33UPXalZiOH7mnILWM1af");

        // const redirectUrl = `https://devtiffintapfrontend.bdccoder.in/login?token=${token}`;
        const redirectUrl = `https://admin.tiffintap.com/login?token=${token}`;
        window.open(redirectUrl, "_self");
      } else {
        toast.error(res?.message || "Redirect failed");
      }
    } catch (err) {
      toast.error("Something went wrong");
    }
  };

  return (
    <div className="fixed top-7 right-4 z-50">
      <button
        onClick={handleBackToAdmin}
        className="bg-green-500 text-white text-xs font-bold px-3 py-2 shadow-lg rounded-lg"
      >
        Go Back to admin
      </button>
    </div>
  );
};

export default GoBackBtn;
